import * as React from "react";
import { SVG } from "../../../../component-configuration/svgs";
import { OfferItem } from "./offer-item";
import isEmpty from "lodash.isempty";

export const OfferSection = (props) => {
  const { entity, section } = props;

  const offers = entity?.marketplace?.edges?.filter((offer: any) => offer?.story?.state === section.status);

  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() - 1);
  const offersNotExpired = offers.filter((offer) => new Date(offer.story.expires) > currentDate);

  const [page, setPage] = React.useState(1);
  const PAGE_SIZE = 12;

  const MoreBreakLine = React.useCallback(() => {
    const total = offers?.length;
    const thereIsMore = total > page * PAGE_SIZE;
    if (!thereIsMore) return null;
    return (
      <div className="more-line-break" onClick={() => setPage(page + 1)}>
        <div className="br" />
        <span>
          <em>{SVG.chevronDown}</em>
        </span>
        <div className="br" />
      </div>
    );
  }, [page, setPage, offers]);

  if (isEmpty(offers)) return null;

  return (
    <div className="marketplace-container">
      {offers?.length !== 0 ? (
        <div>
          <h4 className="section-header">{section.title}</h4>
          <div className="marketplace-row">
            {offers?.slice(0, page * PAGE_SIZE).map((offer) => {
              offer = offer.story;
              return <OfferItem key={offer.id} offer={offer} entity={entity} />;
            })}
          </div>
        </div>
      ) : null}
      <div className="break-line">
        <MoreBreakLine />
      </div>
    </div>
  );
};
